// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-corporate-multidomain -> american-landmark-ala-corporate-multidomain
// Generated: 2026-11-04T18:49:53.124Z
// Counts: 0 design, 44 content, 219 slot group, 0 collection binding, 0 section, 76 style

export const designOverrides = {};

export const contentOverrides = {
  "about-al-one-cta.headline": {
    "overrideType": "VALUE",
    "customValue": "<p>We are powered by technology </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "aboutcontent.map_headline": {
    "overrideType": "VALUE",
    "customValue": "<p>94+ Communities in 10 States</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "alonecontent.arch_body": {
    "overrideType": "VALUE",
    "customValue": "<p>American Landmark's AI strategy integrates traditional property management systems, specialized niche applications, and platform development — so the right intelligence lives where teams already work, and AL-ONE ties it together.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "alonecontent.cta_headline": {
    "overrideType": "VALUE",
    "customValue": "<p>Stronger partnerships with ALA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "alonecontent.intro_body": {
    "overrideType": "VALUE",
    "customValue": "<p>AL-ONE is American Landmark's proprietary asset intelligence platform — designed to analyze portfolio data so our teams can make faster, more confident decisions.</p><p>By bringing every data point into a single, verifiable source of truth, AL-ONE turns complex portfolio information into clear action.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "alonehero.badge": {
    "overrideType": "VALUE",
    "customValue": "<p>AL-ONE</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "alonehero.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<p>Technology</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "alonehero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>How American Landmark puts technology and auditable AI to work — showcased by AL-ONE, our proprietary asset intelligence platform.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "alonehero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>ALA Technology</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "careerscontent.culture_chip_1": {
    "overrideType": "VALUE",
    "customValue": "<p>be a part of something bigger</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "careerscontent.culture_chip_2": {
    "overrideType": "VALUE",
    "customValue": "<p>people first always</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "careerscontent.culture_chip_3": {
    "overrideType": "VALUE",
    "customValue": "<p>make an impact here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "careershero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Build a Career That Matters</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "our-communities::communitieslist.heading": {
    "overrideType": "VALUE",
    "customValue": "<h1>Find your next home</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.company_logo": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "<p>© Copyright 2026 <strong>American Landmark Apartments</strong> | Design &amp; Developed By <a class=\"richtext-link\" href=\"https://www.repli360.com/\"><strong>Repli</strong></a> | Powered By <a class=\"richtext-link\" href=\"https://www.multihub.io/\"><strong>MultiHub</strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "header.company_logo": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.logo": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.menu_background": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b3-4638-77ec-931c-faa1b0b98304.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "investors-al-one-cta.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Built in-house and powered by auditable AI, AL-ONE is the asset intelligence platform behind American Landmark. It brings accuracy and transparency to how we acquire, manage, and dispose of every asset, and it gets sharper with each community we add.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "investors-al-one-cta.headline": {
    "overrideType": "VALUE",
    "customValue": "<p>We are powered by technology </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "investorsapproach.how_body": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Value-add multifamily in high-growth Sun Belt markets</strong>, informed by <strong>deep market experience</strong> and <strong>hyperlocal submarket intelligence</strong>. <strong>Operation, not allocation:</strong> we create value by running the asset, not just funding it.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "investorsapproach.strategy_intro": {
    "overrideType": "VALUE",
    "customValue": "<p>For 30 years, our leadership has focused on one strategy and refined it with every acquisition: buy well-located communities, improve them, and operate them ourselves</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "investorsapproach.what_body": {
    "overrideType": "VALUE",
    "customValue": "<p>We acquire well-located, <strong>mid-priced multifamily communities</strong> and improve their performance through targeted renovations, a <strong>resident-first approach</strong>, and in-house operations.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "investorsapproach.who_body": {
    "overrideType": "VALUE",
    "customValue": "<p>A <strong>vertically-integrated, value-add owner-operator</strong> with <strong>30 years</strong> of multifamily experience. We acquire, renovate, and manage every community in-house, with no third-party managers and no divided interests.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "investorscontent.dash_body": {
    "overrideType": "VALUE",
    "customValue": "<p>The clearest measure of a platform is whether its investors reinvest. Most of our capital comes from partners who have invested with us before, and many have committed across multiple funds. We earn that through consistent execution and transparent, regular reporting. Select a fund to explore returns, deployment, and operating metrics.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "investorscontent.dash_headline": {
    "overrideType": "VALUE",
    "customValue": "<p>Fund performance at a glance. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "investorscontent.footprint_body": {
    "overrideType": "VALUE",
    "customValue": "<p>Our regional teams live and work in the markets we invest in. That local presence gives us submarket-level insight and the ability to act on it quickly, all within one standardized operating platform.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "investorscontent.footprint_headline": {
    "overrideType": "VALUE",
    "customValue": "<p>Local operating teams across eight Sun Belt states.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "investorscontent.form_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Connect with the Capital Markets Team</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "investorscontent.leaders_body": {
    "overrideType": "VALUE",
    "customValue": "<p>Our senior team brings decades of experience across multifamily investment, capital markets, and operations, and sits on the committees that govern every investment decision.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "investorscontent.leaders_headline": {
    "overrideType": "VALUE",
    "customValue": "<p>Experienced leadership, aligned with our partners.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "investorscontent.profile_body": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>Mid-priced, value-add multifamily communities</p></li><li><p>High-growth Sun Belt submarkets with strong job and population growth</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "investorscontent.timeline_body": {
    "overrideType": "VALUE",
    "customValue": "<p>Our track record reflects a platform built across cycles, not a strategy built for one. Tap through the milestones that shaped it.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "investorsstats.stat_1_label": {
    "overrideType": "VALUE",
    "customValue": "<p>Units across four portfolio builds </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "newscontent.intro_headline": {
    "overrideType": "VALUE",
    "customValue": "<p>News and events happening at American Landmark</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "newscontent.latest_eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<h2>Featured</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "strategycontent.pillar_1_tags": {
    "overrideType": "VALUE",
    "customValue": "<p>Market Selection &amp; Sourcing | Underwriting &amp; Analysis | Due Diligence | Capital Structuring | Acquisition Strategy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "strategycontent.pillar_2_tags": {
    "overrideType": "VALUE",
    "customValue": "<p>Construction Management | Interior Design &amp; Renovation | Capital Project Planning | Vendor &amp; Cost Management | Quality Assurance</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "strategycontent.pillar_3_tags": {
    "overrideType": "VALUE",
    "customValue": "<p>Property Management | Portfolio Management | Revenue Management | Resident Experience | Capital Raising &amp; Investor Relations</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "team-bio-aharon-dinovitz.role": {
    "overrideType": "VALUE",
    "customValue": "Managing Director, Private Wealth",
    "generatedValue": null,
    "mappedField": null
  },
  "team-bio-siara-rodriguez-mirabel.role": {
    "overrideType": "VALUE",
    "customValue": "Vice President, Portfolio Management",
    "generatedValue": null,
    "mappedField": null
  },
  "team-bio-tom-lubeck.bio": {
    "overrideType": "VALUE",
    "customValue": "<p>Tom Lubeck serves as Managing Director of Investments at American Landmark in the firm's New York City office. He previously served as Director of Debt &amp; Structured Finance at Newmark (NASDAQ: NMRK), where he directly contributed to $8.26B in transaction volume across 144 transactions for institutional clients. Mr. Lubeck is active in philanthropic efforts supporting Jewish causes, children's charities, and education, and serves on the Board of Volunteers at the Children's Hospital of Philadelphia (CHOP). He earned his Bachelor's degree from Vanderbilt University.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "team-bio-tom-lubeck.role": {
    "overrideType": "VALUE",
    "customValue": "Managing Director, Investments",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "aboutcontent.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b1-ae6d-779a-9c86-3ad4a2081f93.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with gray couch, striped rug, and a glimpse into a bedroom."
      }
    }
  },
  "aboutcontent.stats_bg": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14005-c49d-7699-b561-df66f3c908d6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a resort-style swimming pool and hot tub with lounge chairs on a wooden deck surrounded by trees."
      }
    }
  },
  "abouthero.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14005-823d-7142-a2bd-07aabeb677b4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment building courtyard with illuminated swimming pool and lounge seating at dusk."
      }
    }
  },
  "accessibility-hero.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14023-2a8e-710d-bc4a-6fc59cb54493.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances, white cabinets, and quartz countertops."
      }
    }
  },
  "careerscontent.award_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b2-9c26-7140-9810-a35dc31e57ae.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Top Work Places 2026 Tampa Bay Times logo"
      }
    }
  },
  "careerscontent.award_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b2-9c49-70eb-9f4d-0bd2826fffff.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "USA Today Top Workplaces 2025-2026 award badge"
      }
    }
  },
  "careerscontent.award_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b2-9dd3-71be-8671-96e7bc7e7079.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Top Work Places 2025 award from Houston Chronicle."
      }
    }
  },
  "careerscontent.award_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b2-9fce-73f8-8325-279bbd92a477.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Top Work Places 2023-2025 award logo with Houston Chronicle branding."
      }
    }
  },
  "careerscontent.award_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b2-9d23-7268-99ba-57dd72fdd43c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "NMHC 50 Top Managers 2026 logo."
      }
    }
  },
  "careerscontent.culture_photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6ca-f3b0-778c-8f18-b9a3b039bd60.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman holding a cute, light brown puppy with long floppy ears."
      }
    }
  },
  "careerscontent.culture_photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6ca-9ffc-728e-9567-dffef7fa6c71.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Five people smiling and posing for a photo in front of the BAR ATEN building."
      }
    }
  },
  "careerscontent.culture_photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6ca-eb98-7188-a5c7-078233623ec2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "People playing a Fast & Furious arcade racing game."
      }
    }
  },
  "careerscontent.culture_photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6ca-e05a-76bb-8d99-7f5af596282c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Group of people posing for a photo in front of a green wall with a neon sign and a life preserver."
      }
    }
  },
  "careerscontent.gallery_photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6ca-8a41-745a-ba80-55ccd9ad97bd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Six women smiling and holding Easter baskets and water bottles."
      }
    }
  },
  "careerscontent.gallery_photo_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6ca-9c2d-75f9-a623-eaf745ca916d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Five people standing together in front of palm trees and lush greenery."
      }
    }
  },
  "careerscontent.gallery_photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6ca-cc66-76f7-9568-dac20a1fbbd4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Group of people holding a sign that says Metro Ministries"
      }
    }
  },
  "careerscontent.gallery_photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6ca-ea5f-7770-a166-7c83b3e2ddf8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Group of five women posing for a photo outside a modern building."
      }
    }
  },
  "careerscontent.gallery_photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6cb-5146-70d7-a879-f43465ba3448.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A group of students and an instructor pose for a photo in front of a building."
      }
    }
  },
  "careerscontent.gallery_photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6ca-ca59-766a-8f01-b00b09aa1fcd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A group of people posing for a photo in an office setting."
      }
    }
  },
  "careerscontent.gallery_photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6ca-c494-70ae-9fd5-46ea0d262816.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Four people in a warehouse with a shopping cart filled with items."
      }
    }
  },
  "careerscontent.gallery_photo_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6ca-b34b-7455-8595-e437b309f938.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two men enjoying drinks on a boat with waterfront apartments in the background."
      }
    }
  },
  "careerscontent.gallery_photo_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6ca-9dab-75c8-98e1-b6fd53c628e6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Four men in uniform standing in a common area, smiling."
      }
    }
  },
  "careerscontent.gallery_photo_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6c2-bbc3-707d-a2ba-e9f44b41f879.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Three men hold up signs with 'Thank You' messages and signatures."
      }
    }
  },
  "careerscontent.internship_photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6da-4019-758a-8578-a25fbc2d575b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Group of diverse real estate agents smiling by the pool at a multifamily property."
      }
    }
  },
  "careerscontent.internship_photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6da-21f6-71e8-93fa-22ba16ca10cb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Three women collaborating around a table with a laptop."
      }
    }
  },
  "careerscontent.portfolio_photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14023-4f42-7746-9b64-49ab4fa2091b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool area with lounge chairs and a table with chairs under an umbrella."
      }
    }
  },
  "careerscontent.portfolio_photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b4-1318-759d-a2b8-f5a45a1d9154.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A man in a white shirt laughing while looking down, surrounded by other people."
      }
    }
  },
  "careerscontent.portfolio_photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14005-c49d-7699-b561-df66f3c908d6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a resort-style swimming pool and hot tub with lounge chairs on a wooden deck surrounded by trees."
      }
    }
  },
  "careerscontent.portfolio_photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14005-c4f8-740f-990c-f1fca9bb1c48.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Rooftop lounge area with a fire pit, seating, and bar seating."
      }
    }
  },
  "careerscontent.trademark": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b3-126b-70bb-a45c-747b8f6f1cb1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Property Management Logo"
      }
    }
  },
  "careershero.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14014-3fa9-749d-bffa-7d2b92e92e19.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A diverse group of young professionals collaborating in a modern office setting."
      }
    }
  },
  "our-communities::communitieshero.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14005-a60b-714b-b189-2864b518350d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style pool and lounge area with palm trees and apartment buildings in the background."
      }
    }
  },
  "contacthero.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14023-4628-75e9-82ca-5fda0c252224.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A cafe area with booth seating and tables, decorated with framed art and wall sconces."
      }
    }
  },
  "culturecontent.ethos_img_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14005-8cdd-723e-b807-dd189b288956.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community lounge area with a pool table, seating, and tables."
      }
    }
  },
  "culturecontent.ethos_img_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6e8-54a8-755a-882e-34ff2b3bf504.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A man and a woman posing together in a covered outdoor patio area with seating."
      }
    }
  },
  "culturecontent.ethos_img_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6da-1923-70b4-93a1-8881344cfb0f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Three women collaborate at a table with a laptop."
      }
    }
  },
  "culturecontent.ethos_img_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6ca-ca59-766a-8f01-b00b09aa1fcd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A group of people posing for a photo in an office setting."
      }
    }
  },
  "culturecontent.ethos_img_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6ca-fc4a-74d9-a75b-5e8126d9ee67.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Group of people posing in front of a vibrant mural."
      }
    }
  },
  "culturecontent.ethos_img_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14005-a700-75cb-8094-718e3c7bcffe.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Luxury swimming pool with lounge chairs and cabanas at a multifamily property."
      }
    }
  },
  "culturecontent.ethos_img_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b3-3a7c-729d-a682-bd83f9d6288c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor fire pit seating area with pool and buildings in the background."
      }
    }
  },
  "culturecontent.giving_img_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b2-b3c7-75da-9594-f5839a501a7b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Back of a person wearing a light blue t-shirt with the word VOLUNTEER in black."
      }
    }
  },
  "culturecontent.giving_img_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b2-a02d-7100-8bce-423250f12b40.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A smiling teacher in glasses sits at a desk with two students, with globes visible."
      }
    }
  },
  "culturecontent.giving_img_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1401b-fd39-743e-a9e5-3ee96ecfb612.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A group of children taking a test with focus and concentration in a classroom setting."
      }
    }
  },
  "culturecontent.impact_hero": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b2-bc4a-705f-a6a2-303e45346ad8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A group of volunteers distribute food and aid to a person in a wheelchair."
      }
    }
  },
  "culturecontent.journey_img_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14005-a60b-714b-b189-2864b518350d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style pool and lounge area with palm trees and apartment buildings in the background."
      }
    }
  },
  "culturecontent.journey_img_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14005-7d90-76cc-8e17-d5b76f6e4c67.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with a stone waterfall feature and lounge chairs, with apartment buildings in the background."
      }
    }
  },
  "culturecontent.journey_img_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6ed-5023-7337-a917-2260dcd2370a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Colorful mural with a butterfly and the words Welcome to Mosaic"
      }
    }
  },
  "culturecontent.journey_img_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b4-2981-7479-931f-b72b22a441e6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a modern multifamily apartment building with a parking lot."
      }
    }
  },
  "culturecontent.journey_img_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1400a-e9f0-7354-b06f-8feb8fd8607b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A couple and their dog relax on a couch with a laptop."
      }
    }
  },
  "culturecontent.marquee_img_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6ca-f21e-7548-8807-1f7c052709ec.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "People holding inflatable toys in an arcade"
      }
    }
  },
  "culturecontent.marquee_img_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6ca-bc30-7467-be19-ba895b5a17d4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A group of men posing for a photo at a table in a restaurant."
      }
    }
  },
  "culturecontent.marquee_img_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6ca-ca59-766a-8f01-b00b09aa1fcd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A group of people posing for a photo in an office setting."
      }
    }
  },
  "culturecontent.marquee_img_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6ca-b147-76a3-9959-6b5fde10126a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Group of friends on a boat trip with city skyline in the background"
      }
    }
  },
  "culturecontent.marquee_img_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6c2-bfb3-7460-a1f1-d207cb2b73b8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "People enjoying a pancake bar at a community event."
      }
    }
  },
  "culturecontent.marquee_img_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6c2-a843-7154-9949-de254d32361f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Three men in red shirts and tan pants posing by a reception desk."
      }
    }
  },
  "culturecontent.marquee_img_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6ca-d291-720e-9a1d-696f8d231099.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Four women smiling and posing in front of a stone wall."
      }
    }
  },
  "culturecontent.marquee_img_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6c2-9ed7-7537-b6a9-2759f2595a9b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Group of people gathered around a kitchen island, some holding drinks and snacks."
      }
    }
  },
  "culturecontent.marquee_img_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6ca-ca59-766a-8f01-b00b09aa1fcd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A group of people posing for a photo in an office setting."
      }
    }
  },
  "culturecontent.marquee_img_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6c2-c049-7679-ab8a-db7b69e41f5c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Four men in a golf cart smiling and posing for a photo outdoors."
      }
    }
  },
  "culturehero.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14017-ccbb-7614-b69d-ba919969f856.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Diverse coworkers smiling and posing for a fun selfie in a colorful office setting."
      }
    }
  },
  "faqshero.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14023-2bc5-75a2-86f6-64ac279ef3e1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Stylish resident lounge with plush seating, a modern fireplace, and large windows overlooking the pool area."
      }
    }
  },
  "header.investor_login": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://icx.efrontcloud.com/@4157/americanlandmarkfund/login.aspx"
      }
    }
  },
  "hero.bg_invest": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b3-5330-750b-9dcb-9df603c88109.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with a brown leather sofa, coffee table, and large sliding glass door."
      }
    }
  },
  "hero.bg_live": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b4-324a-72bf-a1ce-1a6dc33460d4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool and lounge area with palm trees and apartment buildings in the background."
      }
    }
  },
  "hero.bg_thrive": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14005-74db-7643-95f9-2d30b4c1dd0a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "People sitting in a park holding inflatable bowling pins and a bowling ball."
      }
    }
  },
  "homeabout.invest_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14005-823d-7142-a2bd-07aabeb677b4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment building courtyard with illuminated swimming pool and lounge seating at dusk."
      }
    }
  },
  "homeabout.live_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14005-bf40-743e-a813-8279c8c05701.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Lounge area with a large TV, island seating, and high-top tables."
      }
    }
  },
  "homeabout.thrive_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b3-52c4-7169-b33e-e1279c192681.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Three women smiling and looking at a laptop, discussing work."
      }
    }
  },
  "homegallery.image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b3-2e86-71bc-b7c6-0a3d9825346b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Lobby seating area with plush green velvet sofas and a tufted brown sofa."
      }
    }
  },
  "homegallery.image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b3-60c6-74be-89cc-623e8a91bde9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "The exterior of the Boulders Lakeside apartment complex with a monument sign."
      }
    }
  },
  "homegallery.image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b3-5aef-760e-9127-c867e04fe47e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Luxurious swimming pool and lounge area surrounded by apartment buildings and lush greenery."
      }
    }
  },
  "homegallery.image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14005-8cdd-723e-b807-dd189b288956.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community lounge area with a pool table, seating, and tables."
      }
    }
  },
  "homelandmark360.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b4-3b2c-70ec-9eac-4142dad8b050.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern lounge area with white sofas, blue accent pillows, and a geometric rug."
      }
    }
  },
  "homeprimeliving.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b4-34e8-715a-8f03-8ebbc3d593e9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Metal horse sculptures in a circular median in front of apartment buildings."
      }
    }
  },
  "homestats.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b4-2981-7479-931f-b72b22a441e6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a modern multifamily apartment building with a parking lot."
      }
    }
  },
  "impactcontent.people_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1401c-a410-746c-8b49-83d574755453.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Diverse group of professionals giving a high-five in an office setting, symbolizing teamwork and success."
      }
    }
  },
  "impactcontent.performance_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14005-cb8a-717a-8875-9759ada8fb5a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern lounge area with seating, tables, and a TV displaying the Metrowen logo."
      }
    }
  },
  "impactcontent.planet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b3-3d5d-74b7-a8ef-a4db02d6f063.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Azure Carnes Crossroads apartment building exterior with a monument sign."
      }
    }
  },
  "impacthero.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14023-457c-762b-8880-a3c42e86fece.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern lounge area with a large sectional sofa and a contemporary coffee table."
      }
    }
  },
  "insightscontent.contact_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": ""
      },
      "label": {
        "type": "VALUE",
        "customValue": "Contact Us"
      }
    }
  },
  "insightshero.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14023-2bc5-75a2-86f6-64ac279ef3e1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Stylish resident lounge with plush seating, a modern fireplace, and large windows overlooking the pool area."
      }
    }
  },
  "investorsapproach.panel_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b4-16f6-7765-91cd-1c399728f2e9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A team collaborating around a laptop, discussing project details."
      }
    }
  },
  "investorsapproach.panel_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14005-8124-72cc-b880-da3397ec892b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious living room with a sectional sofa, coffee table, and entertainment center."
      }
    }
  },
  "investorsapproach.panel_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14005-bc48-705f-84b3-47f800aff86a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor patio area with seating, fire pit, and pergola."
      }
    }
  },
  "investorsapproach.portal_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://icx.efrontcloud.com/@4157/americanlandmarkfund/login.aspx"
      }
    }
  },
  "investorsapproach.strategy_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "LEARN MORE ABOUT US"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/about-us"
      }
    }
  },
  "investorscontent.award_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b2-b225-758f-8526-634b125d4ec5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "National Apartment Association Excellence Awards 2025 Winner logo"
      }
    }
  },
  "investorscontent.award_11": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b2-9d11-754e-ae10-da7623f59aa0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Reputation The 800 Award 2024"
      }
    }
  },
  "investorscontent.award_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b2-9dd3-71be-8671-96e7bc7e7079.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Top Work Places 2025 award from Houston Chronicle."
      }
    }
  },
  "investorscontent.award_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b2-9c26-7140-9810-a35dc31e57ae.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Top Work Places 2026 Tampa Bay Times logo"
      }
    }
  },
  "investorscontent.award_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b2-9fce-73f8-8325-279bbd92a477.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Top Work Places 2023-2025 award logo with Houston Chronicle branding."
      }
    }
  },
  "investorscontent.award_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b2-a08d-7193-85f9-6869adf28ebf.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "ORA Power Rankings Elite 1% award logo by J Turner Research 2023"
      }
    }
  },
  "investorscontent.award_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b2-9d86-702c-8993-a75a2ce4e404.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "NMHC 50 Top Owners 2026 logo"
      }
    }
  },
  "investorscontent.award_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b2-9d23-7268-99ba-57dd72fdd43c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "NMHC 50 Top Managers 2026 logo."
      }
    }
  },
  "investorscontent.award_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b2-9c49-70eb-9f4d-0bd2826fffff.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "USA Today Top Workplaces 2025-2026 award badge"
      }
    }
  },
  "investorscontent.award_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b2-9d17-73bc-b389-ab0ae66f01d7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Top Work Places 2026 logo with Jacksonville.com and The Florida Times-Union"
      }
    }
  },
  "investorscontent.choose_person": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a172-3afc-7659-864b-e1952b633b46.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a man wearing glasses and a suit."
      }
    }
  },
  "investorscontent.leader_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "role": {
        "type": "VALUE",
        "customValue": "Managing Director, Private Wealth"
      }
    }
  },
  "investorscontent.leader_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a182ad-e6c1-763e-aa8c-dbbb406dd8f0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A smiling man with glasses and a beard"
      },
      "role": {
        "type": "VALUE",
        "customValue": "Managing Director, Investments"
      }
    }
  },
  "investorscontent.leader_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "role": {
        "type": "VALUE",
        "customValue": "Vice President, Portfolio Management"
      }
    }
  },
  "investorscontent.leader_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "role": {
        "type": "VALUE",
        "customValue": "Assistant Vice President"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a19cb6-7d44-728c-8ff6-954b4c170383.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Headshot of a smiling man in a suit and tie."
      }
    }
  },
  "investorscontent.leader_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "role": {
        "type": "VALUE",
        "customValue": "Managing Director, MENA"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a188d3-afc8-7710-b87d-00e2ca0d8cc7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Man in a suit with arms crossed"
      }
    }
  },
  "investorscontent.leader_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "role": {
        "type": "VALUE",
        "customValue": "Investment Management Coordinator"
      }
    }
  },
  "investorscontent.leader_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a188da-27f7-74a8-8e97-1b761b2fd5a7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A man wearing glasses and a suit smiles at the camera."
      }
    }
  },
  "investorscontent.login_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://icx.efrontcloud.com/@4157/americanlandmarkfund/login.aspx"
      }
    }
  },
  "investorscontent.partners_portal": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://icx.efrontcloud.com/@4157/americanlandmarkfund/login.aspx"
      }
    }
  },
  "investorscontent.projects_services_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Our team"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/team"
      }
    }
  },
  "investorscontent.team_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Meet the whole team"
      }
    }
  },
  "investorscontent.timeline_portal": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://icx.efrontcloud.com/@4157/americanlandmarkfund/login.aspx"
      }
    }
  },
  "investorscontent.value_portal": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://icx.efrontcloud.com/@4157/americanlandmarkfund/login.aspx"
      }
    }
  },
  "investorshero.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b3-39e4-743b-a44b-1c0bd7cec089.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with a waterfall feature in front of a luxury apartment building at sunset."
      }
    }
  },
  "landmark360content.feature_1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14005-a7f8-7708-8b11-4f0252927926.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious open-concept living and kitchen area with modern finishes."
      }
    }
  },
  "landmark360content.feature_2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b1-bb5a-7258-a88e-c6ddd13a9b27.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Friends enjoying a dinner party at a table with candles and a meal."
      }
    }
  },
  "landmark360content.feature_3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1400d-8347-724e-9f25-1d599614677b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A playful Bengal cat and a Yorkshire Terrier dog enjoy a toy."
      }
    }
  },
  "landmark360content.feature_4_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1400e-1277-767f-a33e-aa89c6497406.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exciting beach volleyball match with players midair diving for the ball on a sunny day."
      }
    }
  },
  "landmark360content.gallery_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6c2-a376-7395-9340-e9210ea80bbe.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A group of people, including children and an adult holding a dog, pose for a photo."
      }
    }
  },
  "landmark360content.gallery_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6c2-c049-7679-ab8a-db7b69e41f5c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Four men in a golf cart smiling and posing for a photo outdoors."
      }
    }
  },
  "landmark360content.gallery_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6c2-c60f-743c-becd-123c3dad2e7b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Four people sitting on a hearth in front of a stone fireplace, discussing documents and using laptops."
      }
    }
  },
  "landmark360content.gallery_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6c2-9955-765c-99f5-0add8a4aa0fc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A team of seven people, all wearing red tops, stands together indoors."
      }
    }
  },
  "landmark360content.gallery_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1a6c2-9ed7-7537-b6a9-2759f2595a9b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Group of people gathered around a kitchen island, some holding drinks and snacks."
      }
    }
  },
  "landmark360content.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b4-bace-762e-bd0f-2423d60a63ab.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Young woman walking with a backpack and coffee cup in front of a corrugated metal door."
      }
    }
  },
  "landmark360content.promise_1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b4-bf18-764f-a35c-9eb3ef225c13.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Couple unpacking boxes, one person looking at a book."
      }
    }
  },
  "landmark360content.promise_2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14005-7b0e-7787-9506-cca289c0b624.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances, granite countertops, and bar stools."
      }
    }
  },
  "landmark360content.promise_3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14005-a6cd-72f4-bb13-0ba62eabc05d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment building exterior with balconies and landscaping."
      }
    }
  },
  "landmark360hero.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b4-bd4c-762a-803e-38f389c2dc0e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Young Black couple laughing and relaxing with their dog on a couch with a laptop."
      }
    }
  },
  "newshero.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14023-2bfe-779e-b95e-0a6f2a4ef974.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with stone fireplace and two sofas."
      }
    }
  },
  "privacy-hero.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14023-470d-70bb-a81a-dd91311f99dd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Waterford Trails monument sign with landscaping."
      }
    }
  },
  "residentportalhero.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a14023-342e-72d6-99c3-1ea03835a787.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas."
      }
    }
  },
  "team-bio-adam-smolyar.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a172-3463-7688-acd2-367555756ebe.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Professional headshot of a smiling man in a suit."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/asmolyar/"
      }
    }
  },
  "team-bio-aharon-dinovitz.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a195-2c1d-7618-8750-1de088b61157.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a smiling man in a suit and tie."
      }
    }
  },
  "team-bio-amy-cox.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a190-936f-7472-8fe5-9fa9ff5e7549.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a smiling woman with blonde hair and a black shirt."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/amy-cox-1a866462/"
      }
    }
  },
  "team-bio-andrew-yam.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a172-2db3-753d-b7e3-6e33c1fef26d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Headshot of a man in a suit and tie."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/andrew-yam-a7005b81/"
      }
    }
  },
  "team-bio-anna-burgess.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a18f-f0bc-7159-9ff0-183bc7a1b2ac.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Headshot of a smiling blonde woman in a black turtleneck."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/anna-burgess-b16283172/"
      }
    }
  },
  "team-bio-ashley-watts.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/ashley-watts-39b993153/"
      }
    }
  },
  "team-bio-bulent-yazar.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/bulent-yazar-72195a172/"
      }
    }
  },
  "team-bio-codi-stepanski.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a15471-48a6-701f-924b-383e3f2e2cc3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Smiling blonde woman with blue eyes and hoop earrings wearing a burgundy shirt."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/codi-stepanski-cam-5b751717b/"
      }
    }
  },
  "team-bio-colby-robertson.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1546d-a968-762c-9a8f-39cf9dc4c5ca.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Smiling man wearing glasses and a navy blue suit jacket over a white shirt."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/colby-robertson-2b42aab0/"
      }
    }
  },
  "team-bio-cole-malizia.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/cole-malizia-ab4b2a98/"
      }
    }
  },
  "team-bio-cortney-myers.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a15472-6e10-7167-b8fe-8be9c0ae4061.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A headshot of a professional blonde woman with blue eyes and red lipstick."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/cortney-myers-854187157/"
      }
    }
  },
  "team-bio-dana-hammond.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1596c-3bb1-74ec-9165-1edbc3764c15.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Professional headshot of a smiling blonde woman with blue eyes, wearing a black blazer and a blue top."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/dana-hammond-naaei-faculty-127bb845/"
      }
    }
  },
  "team-bio-daniel-looft.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1546f-f7ee-7085-ab24-68cbfea5a66e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Headshot of a smiling man in a light blue suit and striped tie."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/daniel-looft-mba-34565852/"
      }
    }
  },
  "team-bio-david-deitz.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a188da-27f7-74a8-8e97-1b761b2fd5a7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A man wearing glasses and a suit smiles at the camera."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": ""
      },
      "email": {
        "type": "VALUE",
        "customValue": "ddeitz@alapts.com"
      }
    }
  },
  "team-bio-david-smith.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a190-9f50-74fb-a497-8ec15d5595fe.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Headshot of a man in a blue suit and tie"
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/davidrolandsmith/"
      }
    }
  },
  "team-bio-debra-claytor.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/debraclaytor/"
      }
    }
  },
  "team-bio-devin-lusk.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a190-0896-7174-a778-bbb3b2dc4719.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Smiling woman with vibrant orange hair, wearing a green blazer over a white shirt."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/devin-lusk-ala/"
      }
    }
  },
  "team-bio-elizabeth-roy.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a172-2c5d-71ef-bca0-056507711bd0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A woman smiling"
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/elizabeth-roy/"
      }
    }
  },
  "team-bio-erik-mancol-bilbo.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a159b0-a803-744d-a407-384a5d9fc3b0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a smiling man in a suit and tie."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/erik-mancol-bilbo-cam-caps-candidate-55518440/"
      }
    }
  },
  "team-bio-fidel-lozano.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a15473-7653-728a-9559-78f5376ea100.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a man in a suit"
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/fidel-lozano-a367b182/"
      }
    }
  },
  "team-bio-hale-mcninch.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a15968-a0ac-7390-9553-890014480120.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a smiling man in a suit and colorful tie"
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/hale-mcninch-096939a/"
      }
    }
  },
  "team-bio-jennifer-hendrix.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a190-0890-7618-abc7-996f18928472.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a smiling woman in a blue blazer"
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/jennifer-h-706509185/"
      }
    }
  },
  "team-bio-jessica-wichser.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/jwichser/"
      }
    }
  },
  "team-bio-jim-miller.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a172-4d4a-722d-80d3-42fd3e61ce9c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Headshot of a smiling man in a suit and light blue shirt."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/james-miller-a30673b8/"
      }
    }
  },
  "team-bio-joe-lubeck.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a172-3afc-7659-864b-e1952b633b46.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a man wearing glasses and a suit."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/joe-lubeck-508a5a27/"
      }
    }
  },
  "team-bio-jr-agostini.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1546e-8bb0-753c-a098-3ff58bc1244b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A man in a suit looking at the camera."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/jr-agostini-28057ba5/"
      }
    }
  },
  "team-bio-julie-doll.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a190-f06e-72fc-be21-f0bd741b4a53.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Smiling blonde woman in a black blazer against a grey background."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/julie-doll-161aa4413/"
      }
    }
  },
  "team-bio-kara-brown.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a18f-f1e9-74e4-b8df-7dc3cee5bc85.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a smiling blonde woman in a black blazer and white shirt."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/kara-brown-arm-6725565/"
      }
    }
  },
  "team-bio-kelsie-jezak.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/kelsie-jezak-3b9a471a2/"
      }
    }
  },
  "team-bio-lee-brown.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a19b-09cd-772e-84ef-14ba43924518.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Headshot of a woman with red hair wearing a suit."
      }
    }
  },
  "team-bio-lisa-santiago.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a15471-59ba-716c-9e6a-f1517962c31e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman smiling in a white blazer."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/lisa-santiago-1b160050/"
      }
    }
  },
  "team-bio-lissette-perez.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/lissette-perez-a9776a108/"
      }
    }
  },
  "team-bio-lucinda-figueroa.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1546d-adfe-716e-99ec-6bd6360cd1e2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Professional headshot of a woman smiling."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/lucindafigueroa/"
      }
    }
  },
  "team-bio-misty-cannon.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/misty-cannon-1738883a4/"
      }
    }
  },
  "team-bio-nakia-ellis.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a190-b36a-7248-808c-38bdbbe1aed2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Smiling woman in a navy blue suit with arms crossed."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/nakia-ellis-cam-33a94259/"
      }
    }
  },
  "team-bio-noah-brown.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/noah-b-brown/"
      }
    }
  },
  "team-bio-patrick-manyeki.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1546e-844f-73d2-98b0-4ceb28e42495.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Professional headshot of a smiling Black man wearing glasses, a blue suit, and a striped tie."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/patrick-manyeki-094192b8/"
      }
    }
  },
  "team-bio-rachel-palmer.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a15966-b1cb-70ef-8f62-2639e76534ca.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a smiling Asian woman with long, dark hair."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/rachel-palmer-8271b319/"
      }
    }
  },
  "team-bio-sara-lowenthal.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a15475-39ea-7079-979b-ca7d177c42cd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a smiling blonde woman with wavy hair, wearing a black blazer over a teal top and a delicate necklace."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/sara-lowenthal-cam-370ab5166/"
      }
    }
  },
  "team-bio-scarlette-pereira.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/scarlette-pereira-a5b20595/"
      }
    }
  },
  "team-bio-shannon-lee.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a190-a434-766c-90be-259f9d88ebcb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a smiling woman with red hair and a black dress"
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/shannonalbrightlee/"
      }
    }
  },
  "team-bio-sheri-brooks.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/s-brooks/"
      }
    }
  },
  "team-bio-siara-rodriguez-mirabel.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/siara-r-289935216/"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a15477-5f1c-77bf-bb5b-17e709449796.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A smiling woman in a blazer and necklace."
      }
    }
  },
  "team-bio-stacey-bondar.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a172-3a53-7238-b4f5-9fbed16000d5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Headshot of a smiling blonde woman in a tan blazer."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/stacey-bondar-cpm-4438a2a/"
      }
    }
  },
  "team-bio-tom-lubeck.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a182ad-e6c1-763e-aa8c-dbbb406dd8f0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A smiling man with glasses and a beard"
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/thomaslubeck/"
      }
    }
  },
  "team-bio-yvonna-groteke.profile": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1546f-f8c6-7100-9274-b0098fd0822d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a smiling blonde woman in a black blazer."
      },
      "linkedin": {
        "type": "VALUE",
        "customValue": "https://www.linkedin.com/in/yvonna-groteke-923099169/"
      }
    }
  },
  "teamcontent.member_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a172-3afc-7659-864b-e1952b633b46.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a man wearing glasses and a suit."
      }
    }
  },
  "teamcontent.member_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a172-3463-7688-acd2-367555756ebe.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Professional headshot of a smiling man in a suit."
      }
    }
  },
  "teamcontent.member_11": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1546d-adfe-716e-99ec-6bd6360cd1e2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Professional headshot of a woman smiling."
      }
    }
  },
  "teamcontent.member_12": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1546d-a968-762c-9a8f-39cf9dc4c5ca.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Smiling man wearing glasses and a navy blue suit jacket over a white shirt."
      }
    }
  },
  "teamcontent.member_13": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a19b-09cd-772e-84ef-14ba43924518.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Headshot of a woman with red hair wearing a suit."
      }
    }
  },
  "teamcontent.member_14": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1546e-8bb0-753c-a098-3ff58bc1244b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A man in a suit looking at the camera."
      }
    }
  },
  "teamcontent.member_15": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1546e-844f-73d2-98b0-4ceb28e42495.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Professional headshot of a smiling Black man wearing glasses, a blue suit, and a striped tie."
      }
    }
  },
  "teamcontent.member_16": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a190-f898-709d-b44c-03f0fc7e27ce.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a woman"
      }
    }
  },
  "teamcontent.member_17": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a190-0896-7174-a778-bbb3b2dc4719.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Smiling woman with vibrant orange hair, wearing a green blazer over a white shirt."
      }
    }
  },
  "teamcontent.member_18": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a190-f06e-72fc-be21-f0bd741b4a53.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Smiling blonde woman in a black blazer against a grey background."
      }
    }
  },
  "teamcontent.member_19": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1546f-f8c6-7100-9274-b0098fd0822d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a smiling blonde woman in a black blazer."
      }
    }
  },
  "teamcontent.member_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a172-4d4a-722d-80d3-42fd3e61ce9c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Headshot of a smiling man in a suit and light blue shirt."
      }
    }
  },
  "teamcontent.member_20": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a1546f-f7ee-7085-ab24-68cbfea5a66e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Headshot of a smiling man in a light blue suit and striped tie."
      }
    }
  },
  "teamcontent.member_21": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a15471-48a6-701f-924b-383e3f2e2cc3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Smiling blonde woman with blue eyes and hoop earrings wearing a burgundy shirt."
      }
    }
  },
  "teamcontent.member_22": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a190-9f50-74fb-a497-8ec15d5595fe.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Headshot of a man in a blue suit and tie"
      }
    }
  },
  "teamcontent.member_23": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a15471-59ba-716c-9e6a-f1517962c31e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman smiling in a white blazer."
      }
    }
  },
  "teamcontent.member_24": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a15472-6e33-760d-bfae-d8694393fc52.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A smiling woman wearing glasses and a black blazer."
      }
    }
  },
  "teamcontent.member_25": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a190-a434-766c-90be-259f9d88ebcb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a smiling woman with red hair and a black dress"
      }
    }
  },
  "teamcontent.member_26": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a190-936f-7472-8fe5-9fa9ff5e7549.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a smiling woman with blonde hair and a black shirt."
      }
    }
  },
  "teamcontent.member_27": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a18f-f0bc-7159-9ff0-183bc7a1b2ac.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Headshot of a smiling blonde woman in a black turtleneck."
      }
    }
  },
  "teamcontent.member_28": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a15472-6e10-7167-b8fe-8be9c0ae4061.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A headshot of a professional blonde woman with blue eyes and red lipstick."
      }
    }
  },
  "teamcontent.member_29": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a18f-fdd0-756f-b3a0-cef4e59975c0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Professional headshot of a man in a suit and tie smiling."
      }
    }
  },
  "teamcontent.member_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a172-2c5d-71ef-bca0-056507711bd0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A woman smiling"
      }
    }
  },
  "teamcontent.member_30": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a15473-7653-728a-9559-78f5376ea100.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a man in a suit"
      }
    }
  },
  "teamcontent.member_31": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a190-0890-7618-abc7-996f18928472.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a smiling woman in a blue blazer"
      }
    }
  },
  "teamcontent.member_32": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a18f-f1e9-74e4-b8df-7dc3cee5bc85.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a smiling blonde woman in a black blazer and white shirt."
      }
    }
  },
  "teamcontent.member_34": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a190-b36a-7248-808c-38bdbbe1aed2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Smiling woman in a navy blue suit with arms crossed."
      }
    }
  },
  "teamcontent.member_35": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a15475-39ea-7079-979b-ca7d177c42cd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a smiling blonde woman with wavy hair, wearing a black blazer over a teal top and a delicate necklace."
      }
    }
  },
  "teamcontent.member_36": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a190-9b07-71bd-9380-f33a3eb8b0cb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Professional portrait of a woman in a white blazer"
      }
    }
  },
  "teamcontent.member_37": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a15475-3b47-717c-adcb-cc6416bb978b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a smiling woman in a blue blazer and white shirt."
      }
    }
  },
  "teamcontent.member_38": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a190-ca53-72af-b73d-d75dc9bf4c10.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Headshot of a smiling woman with blonde hair wearing a blazer and white top."
      }
    }
  },
  "teamcontent.member_39": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a190-8ee0-751e-847b-19e261cae9e5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a smiling woman with blonde hair, wearing a black dress and a diamond necklace."
      }
    }
  },
  "teamcontent.member_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a172-2db3-753d-b7e3-6e33c1fef26d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Headshot of a man in a suit and tie."
      }
    }
  },
  "teamcontent.member_40": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a1a0-248d-7004-bbd6-d12949a81213.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a man in a suit and tie"
      }
    }
  },
  "teamcontent.member_41": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a15476-8b2c-737b-9a24-943b918f4cb8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Professional headshot of a smiling man in a suit and open-collared shirt."
      }
    }
  },
  "teamcontent.member_42": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a15476-8b46-70ea-bbf0-5756cbe4231d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a smiling young professional man in a suit"
      }
    }
  },
  "teamcontent.member_43": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a15477-6744-75fd-bb7c-3e27f2202927.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A smiling woman with short brown hair and gold earrings wearing a dark blue collared shirt."
      }
    }
  },
  "teamcontent.member_44": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a195-2c1d-7618-8750-1de088b61157.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Portrait of a smiling man in a suit and tie."
      }
    }
  },
  "teamcontent.member_45": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a182ad-e6c1-763e-aa8c-dbbb406dd8f0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A smiling man with glasses and a beard"
      },
      "role": {
        "type": "VALUE",
        "customValue": "Managing Director, Investments"
      }
    }
  },
  "teamcontent.member_46": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a15477-5f1c-77bf-bb5b-17e709449796.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A smiling woman in a blazer and necklace."
      },
      "role": {
        "type": "VALUE",
        "customValue": "Vice President, Portfolio Management"
      }
    }
  },
  "teamcontent.member_47": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a188d3-afc8-7710-b87d-00e2ca0d8cc7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Man in a suit with arms crossed"
      }
    }
  },
  "teamcontent.member_48": {
    "sourceIndex": null,
    "fieldOverrides": {
      "dept": {
        "type": "VALUE",
        "customValue": "Capital Markets"
      }
    }
  },
  "teamcontent.member_49": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a188da-27f7-74a8-8e97-1b761b2fd5a7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A man wearing glasses and a suit smiles at the camera."
      }
    }
  },
  "teamcontent.member_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0a172-3a53-7238-b4f5-9fbed16000d5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Headshot of a smiling blonde woman in a tan blazer."
      }
    }
  },
  "teamhero.background": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/01a0f3b4-2981-7479-931f-b72b22a441e6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a modern multifamily apartment building with a parking lot."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {};

export const styleOverrides = {
  "about-al-one-cta.body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "about-al-one-cta.eyebrow": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "aboutcontent.impact_eyebrow": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "alonecontent.ai_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "alonecontent.ai_eyebrow": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "alonehero.subtitle": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "contactform.office_1": {
    "properties": {
      "paddingTop": "10px"
    }
  },
  "contactform.office_2": {
    "properties": {
      "paddingTop": "10px"
    }
  },
  "contactform.office_3": {
    "properties": {
      "paddingTop": "10px"
    }
  },
  "contactform.office_4": {
    "properties": {
      "paddingTop": "10px"
    }
  },
  "culturecontent.cta_body": {
    "properties": {
      "color": "#c2c2c2"
    }
  },
  "culturecontent.giving_1_points": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "culturecontent.giving_2_points": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "culturecontent.giving_3_points": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "culturecontent.impact_nav_label": {
    "properties": {
      "color": "#e8e8e8"
    }
  },
  "culturecontent.stat_1_label": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "culturecontent.stat_2_label": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "culturecontent.stat_3_label": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "culturecontent.stat_4_label": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "impactcontent.archive_label": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "impactcontent.cta_body": {
    "properties": {
      "color": "#bababa"
    }
  },
  "impactcontent.cta_eyebrow": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "impactcontent.env_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "impactcontent.esg_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "impactcontent.esg_eyebrow": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "impactcontent.focus_eyebrow": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "impactcontent.gov_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "impactcontent.people_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "impactcontent.performance_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "impactcontent.planet_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "impactcontent.progress_eyebrow": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "impactcontent.report_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "impactcontent.social_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "insightscontent.cta_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "insightscontent.cta_eyebrow": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "insightscontent.featured_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "insightscontent.featured_eyebrow": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investors-al-one-cta.body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investors-al-one-cta.eyebrow": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.approach_1_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.approach_1_stat_label": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.approach_2_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.approach_2_stat_label": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.approach_3_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.approach_3_stat_label": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.approach_4_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.approach_4_stat_label": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.approach_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.approach_eyebrow": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.diff_eyebrow": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.diff_line_1": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.growth_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.growth_eyebrow": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.stat_1_label": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.stat_2_label": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.stat_3_label": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.step_1_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.step_2_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.step_3_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.step_4_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.step_5_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.step_6_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.thesis_1_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.thesis_2_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "investorscontent.thesis_3_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "newscontent.cta_body": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "newscontent.cta_eyebrow": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "newshero.subtitle": {
    "properties": {
      "color": "#ffffff"
    }
  },
  "strategycontent.advantage_eyebrow": {
    "properties": {
      "color": "#6F7781"
    }
  },
  "strategycontent.stat_1_label": {
    "properties": {
      "color": "#6F7781"
    }
  },
  "strategycontent.stat_2_label": {
    "properties": {
      "color": "#6F7781"
    }
  },
  "strategycontent.stat_3_label": {
    "properties": {
      "color": "#6F7781"
    }
  },
  "strategycontent.stat_4_label": {
    "properties": {
      "color": "#6F7781"
    }
  },
  "strategycontent.stat_5_label": {
    "properties": {
      "color": "#6F7781"
    }
  },
  "strategycontent.stat_6_label": {
    "properties": {
      "color": "#6F7781"
    }
  },
  "strategycontent.stats_eyebrow": {
    "properties": {
      "color": "#6F7781"
    }
  }
};
